import {Injectable} from '@angular/core';
import {AppConstants} from '../../commons/app-constants';
import {isDefined} from '../../commons/utils';
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalizationService {
  private locale: string;

  constructor(private translateService: TranslateService) {
  }

  private static convertToObservable(func: Function): Observable<any> {
    return new Observable(observer =>
      func.call(func, result => {
        observer.next(result);
        observer.complete();
      }, err => {
        observer.error(err);
        observer.complete();
      })
    );
  }

  initGlobalization(): void {
    const globalization = navigator[AppConstants.GLOBALIZATION];
    if (isDefined(globalization)) {
      GlobalizationService.convertToObservable(globalization.getLocaleName)
        .subscribe({
          next: locale => this.setLocale(locale),
          error: () => this.setDefaultLocale()
        });
    } else {
      this.setDefaultLocale();
    }
  }

  private setLocale(locale: { value: string }): void {
    this.locale = locale.value;
  }

  private setDefaultLocale(): void {
    this.locale = this.translateService.getDefaultLang();
  }

  public getLocale(): string {
    return this.locale;
  }
}
